import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAngularEvent, IAugmentedJQuery, IController, IModule, IOnChangesObject, IPromise, IQService, IScope, IWindowService} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import moment from "moment";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {MøteRessurs} from "felles/tjenester/ressurser/MøteRessurs";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {InnlastingsindikatorKontroller} from "../../../basis/direktiver/innlastingsindikator";
import {Debugger} from 'debug'
import {WebNavigasjon} from "../../../../tjenester/WebNavigasjon";
import {changesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Throttle} from "../../../../../felles/tjenester/Throttle";
import {Gruppefarge, gruppefarge} from "felles-ng2/modell/Gruppefarge";


const debug: Debugger = require('debug')('MøteoversiktKontroller');
const css = require('./møteoversikt.scss');


export class MøteoversiktKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmDashboardMoeteoversikt', {
                bindings: {filter: '<'},
                controller: MøteoversiktKontroller.forInjisering(),
                template: require('./møteoversikt.html')
            })
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$q,
            regNavn.ng.$element,
            regNavn.ng.$window,
            Kontekst.regNavn,
            MøteRessurs.regNavn,
            Throttle.regNavn,
            WebNavigasjon.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            MøteoversiktKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $q: IQService,
                private $element: IAugmentedJQuery,
                private $window: IWindowService,
                private kontekst: Kontekst,
                private møteRes: MøteRessurs,
                private throttle: Throttle,
                private navigasjon: WebNavigasjon,
                private meldingTilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog) {
        this.modell = new NavigerbartMøteutsnitt(
            (gruppeIder: string[]) => this.møteRes.finnFørsteMøteOgOmkringliggende2(gruppeIder).$promise,
            (tidligereEnn: Date, gruppeIder: string[]) => this.møteRes.finnMøterMedStartFør(tidligereEnn, gruppeIder).$promise,
            (senereEnn: Date, gruppeIder: string[]) => this.møteRes.finnMøterMedStartEtter(senereEnn, gruppeIder).$promise,
            () => this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Finner ingen tidligere møter')),
            () => this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Finner ingen senere møter'))
        );
    }

    filter: l.DashboardFiltervalg; //settes via bindings/$onChanges

    modell: NavigerbartMøteutsnitt;

    lasterMoeter = false;
    moetedetaljer: { [møteid: string]: l.MøteModell } = {};

    private moetedetaljerPromiser: { [møteid: string]: IPromise<l.MøteModell> } = {};

    private vedResizeHandler:()=>void;

    ingenMoeter() {
        return this.modell && _.isEmpty(this.modell.moeter);
    }

    gruppe(gruppeId: string): l.EnkelGruppeModell {
        return this.kontekst.finnAutentiserteGruppe(gruppeId);
    }

    gruppefarge(gruppeId: string): Gruppefarge {
        return gruppefarge(this.kontekst.finnAutentiserteGruppe(gruppeId));
    }

    lastDetaljer(info: l.MøteMedAggregaterModell): IPromise<l.MøteModell> {
        const møteId = info.moete.id;
        if (this.moetedetaljerPromiser[møteId] === undefined)
            this.moetedetaljerPromiser[møteId] = this.møteRes.hent(møteId).$promise
              .then(møte => {
                  this.moetedetaljer[møteId] = møte;
                  return møte;
              });
        return this.moetedetaljerPromiser[møteId];
    }

    visMoetedokument(info: l.MøteMedAggregaterModell, $event: IAngularEvent) {
        $event.stopPropagation();
        window.open(this.møteRes.møtedokumentUrl(info.moete), "_blank");
    }

    gaaTilAvgiStemme(info: l.MøteMedAggregaterModell, $event: IAngularEvent) {
        $event.stopPropagation();
        this.navigasjon.gåTilMøteAvstemning(info.moete.id);
    }

    erAnsvarligForSak(sak: l.AgendaelementModell) {
        if (sak.erPause) return false;
        return sak.ansvarlig?.brukerId === this.kontekst.autentisertBrukersId();
    }

    $onInit(): void {
        this.beregnMaksMøter();
        this.registrerVedResizeHandler();
    }

    $onDestroy(): void {
        this.avregistrerVedResizeHandler();
    }

    $onChanges(changes: IOnChangesObject): void {
        if (!changesInneholder(changes, 'filter')) return;
        const endretFilter: l.DashboardFiltervalg = changes['filter'].currentValue;
        const opprinneligFilter: l.DashboardFiltervalg = changes['filter'].previousValue;

        InnlastingsindikatorKontroller.visIndikator(this.$scope.$root);
        this.filterEndret(endretFilter, opprinneligFilter)
            .then(() => InnlastingsindikatorKontroller.skjuleIndikator(this.$scope.$root));
    }

    //hjelpemetoder

    private registrerVedResizeHandler(){
        this.vedResizeHandler = this.throttle.throttle(
            () => this.beregnMaksMøter(),
            500);

        angular.element(this.$window).on('resize', this.vedResizeHandler);
    }

    private avregistrerVedResizeHandler(){
        angular.element(this.$window).off('resize', this.vedResizeHandler);
    }

    private beregnMaksMøter(){
        debug("beregnMaksMøter innerWidth", this.$element.innerWidth());
        const tilgjengeligBredde = this.$element.innerWidth() - 60;
        const møtebredde = 150 + (2 * 20);
        this.modell.setMaksAntallMøter(Math.floor(tilgjengeligBredde / møtebredde));
    }

    private filterEndret(nyttFilter: l.DashboardFiltervalg, opprinneligFilter: l.DashboardFiltervalg): IPromise<any> {
        this.filter = nyttFilter; //strengt tatt ikke nødvendig..
        debug("filterEndret", nyttFilter, opprinneligFilter);

        if (!_.isNil(opprinneligFilter) && _.isEqual(opprinneligFilter.gruppeIder, nyttFilter.gruppeIder))
            return this.$q.resolve();

        this.modell.setGruppefilter(nyttFilter.gruppeIder);
        return this.modell.lastMøterOgSettFokusPåFørstkommende();
    }
}

export class NavigerbartMøteutsnitt {

    /**
     * NavigerbartMøteutsnitt kalkuleringsklasse.
     *
     * @param initielleMøter møter initielt tilgjengelig
     * @param tidligereMøter møter som er tidligere enn angitt dato, forventes sortert med tidligste møte først (stigende datorekkefølge)  - det er dette MøteRessurs.finnMøterMedStartFør returnerer
     * @param senereMøter møter som er senere enn angitt dato, forventes sortert med tidligste møte først (stigende datorekkefølge)
     */
    constructor(private initielleMøter: (gruppeIder: string[]) => IPromise<l.MøteMedAggregaterModell[]>,
                private tidligereMøter: (tidligereEnn: Date, gruppeIder: string[]) => IPromise<l.MøteMedAggregaterModell[]>,
                private senereMøter: (senereEnn: Date, gruppeIder: string[]) => IPromise<l.MøteMedAggregaterModell[]>,
                private vedIngenTidligereMøter: () => void,
                private vedIngenSenereMøter: () => void
    ) {
    }

    møter: l.MøteMedAggregaterModell[] = []; //public for testbarhet
    utsnitt = {/** første møte i utvlag, 0-basert */ start: 0, /** siste møte i utvalg, 0-basert */ slutt: 0}; //public for testbarhet
    private maksAntallMøter = 0;
    private valgteGrupper: string[] = [];

    /** aktivt utsnitt - dvs et utsnitt av {@link #møter} definert av {@link #utsnitt} */
    moeter: l.MøteMedAggregaterModell[] = [];

    nesteMoeteIndeks: number|null;

    laster = false;
    lasterSenereMoeter = false;
    ingenSenereMoeter = false;
    lasterTidligereMoeter = false;
    ingenTidligereMoeter = false;


    setMaksAntallMøter(antall: number) {
        this.maksAntallMøter = Math.max(antall, 0);
        debug("plass til antall møter", this.maksAntallMøter, Math.floor(this.maksAntallMøter))
        this.beregnUtsnitt();
        this.oppdaterMoeter();
    }

    setGruppefilter(gruppeIder: string[]) {
        this.valgteGrupper = gruppeIder;
    }

    lastMøterOgSettFokusPåFørstkommende(): IPromise<void> {
        this.laster = true;
        this.ingenTidligereMoeter = false;
        this.ingenSenereMoeter = false;
        return this.initielleMøter(this.valgteGrupper)
            .then(møter => {
                this.møter = møter;
                this.beregnUtsnitt();
                this.oppdaterMoeter();
            })
            .finally(() => this.laster = false)
    }

    /** Laster tidligere møter */
    lastTidligereMoeter() {
        if (this.lasterTidligereMoeter) return; //forhindrer multipler samtidige lastinger av tidligere møter
        //trenger vi å laste flere møter eller har vi alt vi trenger i this.møter?
        if ((this.utsnitt.start - this.maksAntallMøter) >= 0) {
            this.utsnitt.slutt = this.utsnitt.start - 1;
            this.utsnitt.start = (this.utsnitt.slutt - this.maksAntallMøter) + 1;
            this.oppdaterMoeter();
            return;
        }

        debug("lastTidligereMoeter - må laste flere møter, har %s møter, nåværende utsnitt %o", this.møter.length, this.utsnitt);
        this.lasterTidligereMoeter = true;
        this.tidligereMøter(this.gjeldendePeriode().start, this.valgteGrupper)
            .then((møter: l.MøteMedAggregaterModell[]) => {
                if (møter.length == 0) {
                    this.ingenTidligereMoeter = true;
                    if (this.utsnitt.start == 0) {
                        this.vedIngenTidligereMøter();
                        return; //ingen flere møter før nåværende utsnitt
                    }
                }

                this.leggTilMøterFørst(møter)

                //kompanser for at vi har lagt til møter i begynnelse av this.møter
                this.utsnitt.start += møter.length;
                this.utsnitt.slutt += møter.length;

                this.utsnitt.slutt = this.utsnitt.start - 1;
                this.utsnitt.start = Math.max((this.utsnitt.slutt - this.maksAntallMøter) + 1, 0);
                if (this.utsnitt.start == 0)
                    this.utsnitt.slutt = Math.min(this.maksAntallMøter - 1, this.møter.length - 1);

                this.oppdaterMoeter();
            })
            .finally(() => this.lasterTidligereMoeter = false);
    }

    /** Laster senere møter */
    lastSenereMoeter() {
        if (this.lasterSenereMoeter) return; //forhindrer multipler samtidige lastinger av senere møter
        //trenger vi å laste flere møter eller har vi alt vi trenger i this.møter?
        if ((this.utsnitt.slutt + this.maksAntallMøter) <= (this.møter.length - 1)) {
            this.utsnitt.start = this.utsnitt.slutt + 1;
            this.utsnitt.slutt = this.utsnitt.start + this.maksAntallMøter - 1;
            this.oppdaterMoeter();
            return;
        }

        debug("lastSenereMøter - må laste flere møter, har %s møter, nåværende utsnitt %o", this.møter.length, this.utsnitt);
        this.lasterSenereMoeter = true;
        this.senereMøter(this.gjeldendePeriode().slutt, this.valgteGrupper)
            .then(møter => {
                if (møter.length == 0) {
                    this.ingenSenereMoeter = true
                    if (this.utsnitt.slutt == this.møter.length - 1) {
                        this.vedIngenSenereMøter();
                        return; //ingen flere møter etter nåværende utsnitt
                    }
                }

                this.leggTilMøterSist(møter)

                this.utsnitt.start = this.utsnitt.slutt + 1;
                this.utsnitt.slutt = Math.min(this.utsnitt.start + this.maksAntallMøter - 1, this.møter.length - 1);
                if (this.utsnitt.slutt == this.møter.length - 1)
                    this.utsnitt.start = Math.max((this.utsnitt.slutt - this.maksAntallMøter) + 1, 0);

                this.oppdaterMoeter();

            })
            .finally(() => this.lasterSenereMoeter = false);
    }

    private leggTilMøterSist(møter:l.MøteMedAggregaterModell[]) {
        for (const møte of møter) {
            if (!this.møteErAlleredeLagtTil(møte))
                this.møter.push(møte);
        }
    }

    private leggTilMøterFørst(møter:l.MøteMedAggregaterModell[]) {
        // må iterer gjennom baklengs, så de kommer inn i riktig rekkefølge.
        for (const møte of møter.reverse()) {
            if (!this.møteErAlleredeLagtTil(møte)){
                this.møter.unshift(møte);
            }
        }
    }

    private møteErAlleredeLagtTil(møte: l.MøteMedAggregaterModell): boolean {
        for (const m of this.møter) {
            if (m.moete.id === møte.moete.id) return true;
        }
        return false;
    }

    private beregnUtsnitt() {
        if (this.møter.length == 0) {
            this.utsnitt.start = 0;
            this.utsnitt.slutt = 0;
            return;
        }

        const nesteMøteIndeks = this.nesteMøteIndeks();
        if (nesteMøteIndeks >= 0) {
            //vi har et førstkommende møte - vis dette i senter for utvalg
            this.utsnitt.slutt = Math.min((nesteMøteIndeks + Math.floor(this.maksAntallMøter / 2)), this.møter.length - 1);
            this.utsnitt.start = Math.max((this.utsnitt.slutt - this.maksAntallMøter + 1), 0);

            //dersom vi har plass til flere møter - fyll på i begge ender
            let restplasser = this.maksAntallMøter - ((this.utsnitt.slutt - this.utsnitt.start) + 1);
            //fyll først på fremtidige
            const plasserIEnden = Math.min(restplasser, this.møter.length - (this.utsnitt.slutt + 1));
            restplasser -= plasserIEnden;
            this.utsnitt.slutt += plasserIEnden;

            //så paserte om plass til flere
            const plasserIStarten = Math.min(restplasser, this.utsnitt.start);
            this.utsnitt.start -= plasserIStarten;

        } else if (moment(this.møter[0].moete.dato.start).isAfter(moment())) {
            //alle møtene er fremtidige - viser da fra begynnelsen av møtelisten
            this.utsnitt.start = 0;
            this.utsnitt.slutt = Math.min(this.maksAntallMøter - 1, this.møter.length - 1);

        } else {
            //alle møtene er passert - viser da fra slutten av møtelisten
            this.utsnitt.slutt = this.møter.length - 1;
            this.utsnitt.start = Math.max((this.utsnitt.slutt - this.maksAntallMøter + 1), 0);
        }
    }

    /** returnerer index i this.møter til neste møte, -1 dersom ikke funnet (this.møter er tom eller innholder kun passerte møter) */
    private nesteMøteIndeks() {
        const nå = moment();
        const nesteMoeteIndeks = _(this.møter).findIndex(møteinfo => !nå.isAfter(møteinfo.moete.dato.start, "hour"));
        return nesteMoeteIndeks;
    }

    private oppdaterMoeter() {
        this.oppdaterNesteMoeteIndeks();
        this.moeter = this.møter.slice(this.utsnitt.start, this.utsnitt.slutt + 1); //slice tar til slutt - ikke til og med slutt
        debug("oppdaterMoeter: %s møter (%O), nåværende utsnitt %o, nestemoeteindeks %s, maksantmøter %s", this.møter.length, this.møter, this.utsnitt, this.nesteMoeteIndeks, this.maksAntallMøter);
    }

    private oppdaterNesteMoeteIndeks(): number {
        const nesteMøteIndeks = this.nesteMøteIndeks();
        this.nesteMoeteIndeks = nesteMøteIndeks >= 0 ? nesteMøteIndeks - this.utsnitt.start : null;
        return
    }

    private gjeldendePeriode() {
        return {
            start: this.møter.length > 0 ? this.møter[0].moete.dato.start : null,
            slutt: this.møter.length > 0 ? _(this.møter).last().moete.dato.start : null
        }
    }

}
